<template>
  <div class="score" v-show="this.detailsManyData.resultMap&&this.detailsManyData.resultMap.scoreAVG">
    <div class="myCharts">
      <div class="bt">
        <img src="../../../assets/icon_sleepScore.png" alt="" />
        <span v-if="this.detailsManyData.resultMap&&this.detailsManyData.resultMap.scoreAVG">
			睡眠得分  平均{{ detailsManyData.resultMap.scoreAVG.toFixed(0) }}分</span>
      </div>
      <div
        id="myChartScores"
        style="height: 126px; margin: 10px auto"
        key="scores"
      ></div>
    </div>
  </div>
</template>


<script>
export default {
  props: {
    score: 0,
    detailsManyData: {},
    dataTitleList: null,
  },
  data() {
    return {
      myChartScores: null,
      good: 0,
    };
  },
  methods: {
    getChartScores() {
	  if (this.myChartScores != null && this.myChartScores!= "" && this.myChartScores!= undefined) {
	  	this.myChartScores.dispose();
	  }
      this.myChartScores = this.$echarts.init(
        document.getElementById("myChartScores")
      );
	  var scoreX = [];
	  for(var i = 0; i < this.detailsManyData.resultMap.scoreX.length; i++){
		  scoreX[i] = this.detailsManyData.resultMap.scoreX[i].replace(",", "-");
	  }
	  var scoreY = [];
	  for(var i = 0; i < this.detailsManyData.resultMap.scoreY.length; i++){
		  if(this.detailsManyData.resultMap.scoreY[i] != 0){
			  scoreY[i] = this.detailsManyData.resultMap.scoreY[i];
		  }else {
			  scoreY[i] = null;
		  }
	  }
      var optionScore = {
        color: ["#1890FF"],
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          borderColor: "rgba(24, 144, 255, 0.8)",
          // borderWidth: 1,
          borderRadius: 5,
          //   formatter: function (params) {
          //     console.log(params[0].data);
          //     return params[0].data;
          //   },
        },
        grid: {
          left: "0%",
          right: "0%",
          top: "10%",
          bottom: "0%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            axisLabel: {
              textStyle: {
                color: "rgba(0,0,0,0.35)", //坐标的字体颜色
              },
            },
            axisLine: {
              lineStyle: {
                color: "rgba(0,0,0,0.15)",
              },
            },
            //data: this.detailsManyData.resultMap.scoreX,
			data: scoreX,
          },
        ],

        yAxis: [
          {
            type: "value",
            min: 0,
            max: 100,
            logBase: 10,
            interval: 1000,
            splitLine: {
              show: false,
            },
            axisLabel: {
              formatter: "{value}",
              textStyle: {
                color: "rgba(0,0,0,0.35)", //坐标的字体颜色
              },
            },
            axisLine: {
              lineStyle: {
                color: "rgba(0,0,0,0.15)",
              },
              show: true,
            },
          },
        ],
        series: [
          {
			//data: this.detailsManyData.resultMap.scoreY, 
            data: scoreY,
            type: "line",
            smooth: true,
            symbol: "circle",
            symbolSize: 8,
            color: "#1890FF",
            markLine: {
              symbol: "none",
              emphasis: {
                lineStyle: {
                  width: 1, // hover时的折线宽度
                },
              },
              data: [
                {
                  silent: false, //鼠标悬停事件  true没有，false有
                  lineStyle: {
                    //警戒线的样式  ，虚实  颜色
                    type: "dashed",
                    color: "#C394FE",
                  },
                  label: {
                    position: "end",
                    formatter: "",
                  },
                  yAxis: this.detailsManyData.resultMap.scoreAVG, // 警戒线的标注值，可以有多个yAxis,多条警示线   或者采用   {type : 'average', name: '平均值'}，type值有  max  min  average，分为最大，最小，平均值
                },
              ],
            },
          },
        ],
      };

      this.myChartScores.clear();
      this.myChartScores.setOption(optionScore);
      window.addEventListener("resize", () => {
        this.myChartScores.resize();
      });

      //模拟得分仪表盘
    },
  },
  mounted() {},
};
</script>

<style lang="scss">
</style>
